export default {
  success: 'success',
  error: 'error',
  warning: 'warning',
  confirm: 'confirm',
  userRoadBlock: 'user-road-block',
};
